angular.module('forms').directive('apFormAnswerCheckbox',
    ['$rootScope', 'aprgettext',
        function ($rootScope, gettext) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerCheckbox.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    form: '=form',
                    question: '=question',
                    answer: '=answer',
                    lastQuestion: '@lastQuestion'
                },
                controller: function($scope) {

                    $scope.explanationPlaceHolder = {
                        Text : ''
                    };

                    function enableQuestionsForSelectedAnswer(enableQuestion) {
                        var answer = $scope.answer;

                        // if answer.QuestionsToTrigger collection is empty, do not fire enable event
                        _.forEach(answer.QuestionsToTrigger, function(questionToEnable) {
                            if (questionToEnable !== '00000000-0000-0000-0000-000000000000') {
                                $rootScope.$broadcast('FormAnswerChanged',
                                    {
                                        EnableQuestion: enableQuestion,
                                        QuestionIdToTrigger: questionToEnable
                                    });
                            }
                        });
                    }


                    $scope.answerChanged = function answerChanged() {
                        enableQuestionsForSelectedAnswer($scope.answer.SelectedAnswer);

                        if ($scope.answer.SelectedAnswer === true ) {
                            $scope.explanationPlaceHolder.Text = gettext('Required Explanation here');
                        } else {
                            $scope.explanationPlaceHolder.Text = '';
                        }

                        if ($scope.answer.SurveyRequiresExplanation === false) {
                            $scope.explanationTextChanged();
                        }
                    };


                    $scope.explanationTextChanged = function explanationTextChanged() {
                        $rootScope.$broadcast('ExplanationTextChanged',
                            {
                                SurveyAnswerId: $scope.answer.SurveyAnswerId,
                                SurveyQuestionId: $scope.answer.SurveyQuestionId
                            }
                        );
                    };


                    function loadView() {
                    }
                    loadView();
                }
            };
        }
    ]
);